// Services
import addressFinderAutocompleteService from '@/app/services/address-finder/address-finder-autocomplete/address-finder-autocomplete-service.js';
import userService from '@/app/services/main/user/user-service.js';
import walkerSitterService from '@/app/services/main/walker-sitter/walker-sitter-service.js';
import breedService from '@/app/services/main/breed/breed-service.js';

// Utils
import { vuelidateUtil } from '@/utils/vuelidate-util.js';

// Constants
import { GA } from '@/app/constants/ga-constants';
import { STATUS_CODES, SUCCESS_MSG } from '@/app/constants/status-constants';

// Mixins
import { GoogleAnalyticsMixins } from '@/app/mixins/utils/google-analytics-mixins';
import { dateMixins } from '@/app/mixins/utils/date-mixins';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { imageCompressorMixins } from '@/app/mixins/utils/image-compressor-mixins';
import { inputTextMixins } from '@/app/mixins/utils/input-text-mixins';
import { userMixins } from '@/app/mixins/modules/user-mixins.js';
import { addressMixins } from "@/app/mixins/utils/address-mixins"

// Third Party Libraries
import { mapState } from 'vuex';

// Components
const FileUpload = () => import(/* webpackPrefetch: true, webpackChunkName: "file-upload" */ '@/app/views/main-view/_shared/_components/file-upload/file-upload.vue');
const scheduleComponent = () => import(/* webpackPrefetch: true, webpackChunkName: "schedule-component" */ '@/app/views/main-view/walker-sitter-profile/module/schedule-component/schedule-component.vue');

export default {
	name: 'WalkerSitterProfileContainer',
	components: { 
		FileUpload,
		scheduleComponent
	},
	mixins: [
		GoogleAnalyticsMixins,
		dateMixins,
		toastMessageMixins,
		imageCompressorMixins,
		inputTextMixins,
		userMixins,
		addressMixins
	],
	data() {
		return {
			inputFields: {
				firstName: '',
				lastName: '',
				email: '',
				selectedTimeZone: 'Australia/Sydney',
				coverage: 0,
				bio: '',
				address: '',
				type:'',
				profileImageUpload: '',
				mobileNumber: '',
				freeOfCharge: false,
				perHour: 0.00,
				perDay: 0.00
			},
			imageLink: '',
			isAgreeTNC: false,
			isAPILoading: false,
			imageToCrop: '',
			addressList: [],
			isAddressLoading: false,
			roleOptions: [
				{ value: 4, option: 'Walker' },
				{ value: 5, option: 'Sitter' },
				{ value: 6, option: 'Walker and Sitter' }
			],
			theads: [
				{ name: 'Select Preferred Breeds', searchLabel: null, sortLabel: null, isDesc: false, hasSearch: true, style: null },
				{ name: null, searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, hasToggle: true, style: 'width: 15%;' }
			],
			selectedBreeds: [],
			headerToggleCheckbox: false,
			filter: '',
			setScreen:'setupProfile',
			titleHeaders:'Setup Profile',
			tabs: [
				{ label: "Profile", id: 1, active: true },
				{ label: "Breeds", id: 2, active: false },
				{ label: "Schedule", id: 3, active: false },
			],
			mobileNumberIsValid:true,
			updateImage:false
		}
	},
	computed: {
		...mapState({
			setupProfile: state => state.registrationPetDetails.registrationUserDetails,
			profileImageSrc: state => state.registrationPetDetails.profileImageSrc
		}),
		validationRules() {
			let fields = {
				inputFields: {
					firstName: {},
					lastName: {},
					mobileNumber: {},
					address: {},
					coverage: {},
					bio: {},
					profileImageUpload: {},
					type:{}
				}
			};

			fields.inputFields = vuelidateUtil.setFieldsRequired(fields.inputFields, true);
			fields.inputFields = vuelidateUtil.setEmailValidation(fields.inputFields, 'email');

			fields.inputFields.perDay = {};
			fields.inputFields.perHour = {};

			if (!this.inputFields.freeOfCharge && this.inputFields.type) {
				// Walker
				if (this.inputFields.type === 4) {
					fields.inputFields.perDay = {};
					fields.inputFields = vuelidateUtil.setRequiredValidation(fields.inputFields, 'perHour');
				} else if (this.inputFields.type === 5) {
					// Sitter
					fields.inputFields.perHour = {};
					fields.inputFields = vuelidateUtil.setRequiredValidation(fields.inputFields, 'perDay');
				} else {
					// Walker Sitter
					fields.inputFields = vuelidateUtil.setRequiredValidation(fields.inputFields, 'perHour');
					fields.inputFields = vuelidateUtil.setRequiredValidation(fields.inputFields, 'perDay');
				}
			}

			return fields;
		},
		isDisabled() {
			return this.$v.$invalid || this.isAPILoading;
		},
		isDisabledCreateProfile() {
			return this.selectedBreeds.length === 0;
		},
		isUserInfoChange() {
			const {
				firstName,
				lastName,
				userRole,
				address,
				walkerSitterDetails
			} = this.userDetails;

			let role;
			switch (userRole)  {
				case 'WALK':
					role = 4;
					break;

				case 'SITT':
					role = 5;
					break;
				
				default:
					role = 6;
					break;
			}

			let mobileChange = true;
			let mobileNumber = '';
			let freeOfCharge, perHour, perDay;

			if (walkerSitterDetails) {
				mobileNumber = walkerSitterDetails.mobileNumber === null ? '':walkerSitterDetails.mobileNumber;
				freeOfCharge = this.inputFields.freeOfCharge === walkerSitterDetails.freeOfCharge;
				perHour = this.inputFields.perHour === walkerSitterDetails.perHour;
				perDay = this.inputFields.perDay === walkerSitterDetails.perDay;
			}

			if (this.inputFields.mobileNumber.length === 11 || this.inputFields.mobileNumber.length === 0) {
				mobileChange = this.inputFields.mobileNumber.replace('-', '') === mobileNumber;
			}
			
			let newAddress = this.inputFields.address === null ? '': this.inputFields.address.full_address;

			const walkerSitterCoverage = walkerSitterDetails ? walkerSitterDetails.coverage : this.inputFields.coverage;
			const walkerSitterBiography = walkerSitterDetails ? walkerSitterDetails.biography : this.inputFields.bio;

			return (
				this.inputFields.lastName === lastName &&
				this.inputFields.firstName === firstName &&
				newAddress === address &&
				this.inputFields.type === role &&
				parseInt(this.inputFields.coverage) === parseInt(walkerSitterCoverage) &&
				this.inputFields.bio === walkerSitterBiography &&
				!this.updateImage && mobileChange && freeOfCharge && perHour && perDay);
		},
		isUpdateBreed() {
			const { walkerSitterDetails} = this.userDetails;

			if (walkerSitterDetails) {
				let oldBreeds = walkerSitterDetails.breed.map(item => (item.id));
				let oldBreedList = oldBreeds.sort();
				let newBreedList = this.selectedBreeds.sort();
				let identical = Array.isArray(newBreedList) &&
					Array.isArray(oldBreedList) &&
					newBreedList.length === oldBreedList.length &&
					newBreedList.every((val, index) => val === oldBreedList[index]);	
					return (identical || this.selectedBreeds.length === 0);
			}
			return false;
		},
		hasUploaded() {
			let img = '';
			if (this.profileImageSrc) {
				img = this.profileImageSrc;
				this.imageLink = this.profileImageSrc;
			} else if (this.imageLink !== '') {
				img = this.imageLink;
			} else {
				img = require('@/assets/images/_shared/default-profile-pic.png')
			}

			return img;
		},
		selectedType() {
			let type = '';
			
				switch (this.inputFields.type) {
					case 4 : type = 'Walker'; break;
					case 5 : type = 'Sitter'; break;
					case 6 : type = 'Walker and Sitter'; break;
					default: type = 'Type'; break
				}

			return type;
		},
		breedLists() {
			return this.$store.getters.getBreedLists;
		},
		geoLocation() {
			return this.$store.getters.getGeoLocation;
		},
		displayBreeds() {
			if (this.filter.trim !== '') {
				return this.$store.getters.getBreedLists.filter(breed => { 
					if (breed.name.toLowerCase().includes(this.filter.toLowerCase())) {
						return  breed;
					}
				});
			} else {
				return this.$store.getters.getBreedLists;
			}
		},
		getActiveTab() {
			return this.tabs.find(tab => tab.active);
		},
		
	},
	watch: {
		selectedBreeds(newVal) {
			if (newVal) {
				if (newVal.length !== this.breedLists.length) {
					this.headerToggleCheckbox = false;
				} else {
					this.headerToggleCheckbox = true;
				}
			}
		},
		'inputFields.coverage': {
			immediate: true,
			handler(newVal) {
				if (newVal) {
					if ( newVal <= 100 ) {
						this.inputFields.coverage = newVal;
					} else {
						this.inputFields.coverage = newVal.slice(0, -1);
					}
				}
			},
			deep: true
		}
	},
	async created() {
		this.populateData();
	},
	methods: {
		populateData() {
			const {
				firstName,
				lastName,
				emailAddress,
				userRole,
				address,
				userAddress,
				walkerSitterDetails,
				imageURL
			} = this.userDetails;

			this.inputFields.firstName = firstName;
			this.inputFields.lastName = lastName;
			this.inputFields.email = emailAddress;

			if (userRole === 'CUST') {
				this.titleHeaders = 'Setup Profile';
				// this.inputFields.address = JSON.parse(`{"label": "address", "displayAddress": "${this.formatAddressStatePostCode(address)}", "full_address": "${address}"}`) || "";
			} else {
				this.titleHeaders = 'Walker / Sitter Profile';
				this.inputFields.coverage = walkerSitterDetails.coverage;
				this.inputFields.bio = walkerSitterDetails.biography;
				this.inputFields.freeOfCharge = !!walkerSitterDetails.freeOfCharge;
				this.inputFields.perDay = isNaN(walkerSitterDetails.perDay) ? 0.00 : walkerSitterDetails.perDay;
				this.inputFields.perHour = isNaN(walkerSitterDetails.perHour) ? 0.00 : walkerSitterDetails.perHour;
				this.$store.commit('setProfileImageSrc', imageURL);
				this.inputFields.profileImageUpload = imageURL;
				// this.inputFields.address = JSON.parse(`{"label": "address", "displayAddress": "${address}"}`);
				this.inputFields.address = JSON.parse(`{"label": "address", "displayAddress": "${this.formatAddressStatePostCode(userAddress)}", "full_address": "${userAddress}"}`) || "";
				this.selectedBreeds = walkerSitterDetails.breed.map(item => (item.id));
				this.geoLocation.latitude = walkerSitterDetails.latitude
				this.geoLocation.longitude = walkerSitterDetails.longitude
				
				switch (userRole)  {
					case 'WALK':
						this.inputFields.type = 4;
						break;
					case 'SITT':
						this.inputFields.type = 5;
						break;
					default:
						this.inputFields.type = 6;
						break
				}
				
				if (walkerSitterDetails.mobileNumber) {
					let data = walkerSitterDetails.mobileNumber.split('');
						data.splice(4, 0, '-');
					this.inputFields.mobileNumber = data.join('');
				}
			}
		},
		getBreedList() {
            breedService.getBreeds()
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.isAPILoading = false;
						this.breedList = res.data.data;
						this.$store.commit('setBreedLists', this.breedList);
					} else {
						const { ERROR_GET_BREED_LIST } = this.toastMessages.breed();
						this.showAPIErrorToast(ERROR_GET_BREED_LIST, res);
					}
				});
        },
		toggleSelectDeselect(event) {
			this.headerToggleCheckbox = event.target.checked;

			if (this.headerToggleCheckbox) {
				this.selectedBreeds = this.breedLists.map(breed => { return breed.id; });
			} else {
				this.selectedBreeds = [];
			}
		},
		toggleApplicableBreed (event, breedId) {
			if (event.target.checked) {
				this.selectedBreeds.push(breedId);
			} else {
				const i = this.selectedBreeds.indexOf(breedId);
				this.selectedBreeds.splice(i,1);
			}
		},
		setActiveComponent() {
			this.$emit('setActiveComponent', 'add-pet');
		},
		setActiveTab(selectedTab) { 
			this.getUserDetailsAPI();
			this.populateData();
			
			switch (selectedTab) {
				case 1:	
					this.activeScreen("setupProfile");
					break;
				case 2:	
					this.activeScreen("breedPrefer");
					break;
				default:
					this.activeScreen("schedule");
					break;
			}

			this.tabs = this.tabs.map(tab => {
				// set the selected tab to active
				tab.active = tab.id === selectedTab;

				return tab;
			});
		},
		async createProfile() {
			this.isAPILoading = true;
			let walkerSitterDetails = {
				formData: {
					user: {
						firstName: this.inputFields.firstName,
						lastName: this.inputFields.lastName,
						address: this.inputFields.address.full_address,
						latitude: this.geoLocation.latitude,
						longitude: this.geoLocation.longitude,
						isImageChanged: true
					},
					walkerSitter: {
						mobileNumber: this.inputFields.mobileNumber.replace('-', ''),
						biography: this.inputFields.bio,
						coverage: this.inputFields.coverage,
						breed: this.selectedBreeds,
						role: this.inputFields.type,
						freeOfCharge: this.inputFields.freeOfCharge,
						perHour: isNaN(this.inputFields.perHour) ? 0.00 : this.inputFields.perHour,
						perDay: isNaN(this.inputFields.perDay) ? 0.00 : this.inputFields.perDay
					}
				},
				userImage: this.inputFields.profileImageUpload[0]
			};

			userService.putUserRole(this.userDetails.id, { roleId: this.inputFields.type })
				.then(res => {
					if (res.status === 200) {
						walkerSitterService.putWalkerSitterDetails(walkerSitterDetails)
							.then(resp => {
								this.isAPILoading = false;
								if (resp.status === 204 ) {
									const { SUCCESS_CREATED_PROFILE } = this.toastMessages.user();

									this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_CREATED_PROFILE);
								} else {
									this.showCustomErrorToast(resp.data.errors[0].message, null, true);
								}

								// refresh user details and only after the promise is fulfilled, thus the ".then"
								this.getUserDetailsAPI().then(() => {
									this.populateData();

									this.activeScreen("setupProfile");

									this.updateImage = false;
									this.filter='';
								})
								
							});			
					}
				});
		},
		async updateProfile() {
			if (this.$v.$invalid || this.isUserInfoChange) {
				return;
			}

			let user = {
				firstName: this.inputFields.firstName,
				lastName: this.inputFields.lastName,
				address: this.inputFields.address.full_address,
				isImageChanged: this.updateImage
			};

			let walkerSitter = {
				biography: this.inputFields.bio,
				coverage: this.inputFields.coverage,
				breed: this.selectedBreeds,
				role: this.inputFields.type,
				freeOfCharge: this.inputFields.freeOfCharge,
				perHour: isNaN(this.inputFields.perHour) ? 0.00 : this.inputFields.perHour,
				perDay: isNaN(this.inputFields.perDay) ? 0.00 : this.inputFields.perDay
			};
			
			if (this.geoLocation.latitude) {
				user.latitude = this.geoLocation.latitude;
				user.longitude = this.geoLocation.longitude;
			}

			if (this.inputFields.mobileNumber && this.inputFields.mobileNumber.length > 0) {
				walkerSitter.mobileNumber =  this.inputFields.mobileNumber.replace('-', '');
			}

			let walkerSitterDetails = {
				formData: {
					user,
					walkerSitter
					},userImage: this.inputFields.profileImageUpload[0]
				};
					
			walkerSitterService.putWalkerSitterDetails(walkerSitterDetails)
				.then(res => {
					this.isAPILoading = false;
						if (res.status === 204 ) {
							const { SUCCESS_UPDATE_PROFILE } = this.toastMessages.user();

							this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_UPDATE_PROFILE);
						} else {
							this.showCustomErrorToast(res.data.errors[0].message, null, true);
						}

						//refresh user details
						this.getUserDetailsAPI();
				});	
		},
		async updateBreed() {
			if (this.isUpdateBreed) {
				return;
			}
		
			let user = {
				firstName: this.inputFields.firstName,
				lastName: this.inputFields.lastName,
				address: this.inputFields.address.full_address,
				isImageChanged: false
			};

			let walkerSitter = {
				biography: this.inputFields.bio,
				coverage: this.inputFields.coverage,
				breed: this.selectedBreeds,
				role: this.inputFields.type,
				freeOfCharge: this.inputFields.freeOfCharge,
				perHour: isNaN(this.inputFields.perHour) ? 0.00 : this.inputFields.perHour,
				perDay: isNaN(this.inputFields.perDay) ? 0.00 : this.inputFields.perDay
			};
			
			if (this.geoLocation.latitude) {
				user.latitude = this.geoLocation.latitude;
				user.longitude = this.geoLocation.longitude;
			}
			
			if (this.inputFields.mobileNumber && this.inputFields.mobileNumber.length > 0) {
				walkerSitter.mobileNumber =  this.inputFields.mobileNumber.replace('-', '');
			}

			let walkerSitterDetails = {
				formData: {user,walkerSitter}};
					
			walkerSitterService.putWalkerSitterDetails(walkerSitterDetails)
				.then(res => {
					this.isAPILoading = false;
						if (res.status === 204 ) {
							const { SUCCESS_UPDATE_BREED } = this.toastMessages.user();

							this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_UPDATE_BREED);
						} else {
							this.showCustomErrorToast(res.data.errors[0].message, null, true);
						}

						//refresh user details
						this.getUserDetailsAPI();
						//clear breed search field
						this.filter='';
				});	
		},
		removedWasi() {
			this.$swal({
				imageHeight: '30px',
				title: `Remove walker or sitter profile?`,
				imageUrl: `${require('@/assets/images/_shared/sad-dog.png')}`,
				confirmButtonText: 'Confirm',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				reverseButtons: true
			})
			.then(result => {
				if (result) {
					if (result.value) {

						this.isAPILoading = true;
						userService.putUserRole(this.userDetails.id, { roleId: 1 })
							.then(res => {
								this.isAPILoading = false;
								if (res.status === 200 ) {
									const { SUCCESS_REMOVED_PROFILE } = this.toastMessages.user();

									this.$store.commit('clearAddPetDetails');
									
									this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_REMOVED_PROFILE);

									this.getBreedList();
								} else {
									this.showCustomErrorToast(res.data.errors[0].message, null, true);
								}
						
								// refresh user details
								this.getUserDetailsAPI();

								this.$router.push('/dashboard');
							});
					}
				}
			});
		},
		async onUploadImage(event) {
			let valid = await this.validateImage(event.target.files[0]);
			// do nothing when user cancels Upload
			if (!valid) {
				// reset uploader
				this.$refs.imgUploader.value = '';
				return;
			}

			// compress image if more than 2mb
			const file = await this.compressImage(event.target.files[0]);

			this.setupProfile.profileImage = [file];
			// show preview of pet image 
			let reader = new FileReader();

			reader.onload = () => {
				this.imageToCrop = reader.result;
				this.$refs.modalFileUpload.show();
			}

			this.sendEventTrackingToGA(GA.REGISTRATION_PAGE.ADD_PET_IMAGE.ACTION, GA.REGISTRATION_PAGE.CATEGORY, GA.REGISTRATION_PAGE.ADD_PET_IMAGE.LABEL);
			reader.readAsDataURL(file); 
		},
		clearFileInput(event) {
			event.target.value = '';
		},
		findAddress(address) {
			if (address) {
				this.isAddressLoading = true;

				this.delayTyping(() => {
					this.getAutocompleteAddress(address);
				});
			}
		},
		async onBlur(field) {
			if (field === 'address') {
				this.$v.inputFields.address.$touch();

				if (this.inputFields.address) {
					await this.getAddressMetaData(this.inputFields.address);
				}
			}
		},
		async setSelectedAddress() {
            this.$v.inputFields.address.$touch();

            if (this.inputFields.address) {
                await this.getAddressMetaData(this.inputFields.address);
            }
        },
		onSelectedType(type) {
			this.inputFields.type = type;
		},
		getAutocompleteAddress(address) {
			addressFinderAutocompleteService.getAutocompleteAddress(address)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.addressList = res.data.completions.map(add => { 
							let tempAddress = add.full_address.split(" ");
							add.displayAddress = `${tempAddress[tempAddress.length - 2]} ${tempAddress[tempAddress.length - 1]}`;
							add.label = add.id;
							return add; 
						});
						this.isAddressLoading = false;
					} else {
						const { ERROR_GET_ADDRESS } = this.toastMessages.addressFinder();
						this.showAPIErrorToast(ERROR_GET_ADDRESS, res);
						this.isAddressLoading = false;
					}
				})
				.catch(() => {
					this.showGenericErrorToast();
					this.isAddressLoading = false;
				});
		},
		async getAddressMetaData(address) {
			addressFinderAutocompleteService.getAddressMetaData(address.id)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						const { latitude, longitude } = res.data;
						this.$store.commit('setGeoLocation', { latitude, longitude });
					} else {
						const { ERROR_GET_ADDRESS } = this.toastMessages.addressFinder();
						this.showAPIErrorToast(ERROR_GET_ADDRESS, res);
						this.isAddressLoading = false;
					}
				})
				.catch(() => {
					this.showGenericErrorToast();
					this.isAddressLoading = false;
				});
		},
		setImageCrop({image, blob}) {
			this.$store.commit('setProfileImageSrc', image);
			this.setupProfile.profileImageUpload = blob;
			this.inputFields.profileImageUpload = blob;
			this.updateImage = true;
		},
		filterBreed(event) {
			this.delayTyping(() => {
				this.filter = event.target.value;
			});
		},
		activeScreen(string) {
			this.setScreen = string;
		},
		mobileNumberFormat(event) {
			this.mobileNumberIsValid = true;

			this.inputFields.mobileNumber = this.formatMobileNumberOnChange(event);
		},

		onPasteMobileNumber(event) {
			event.preventDefault(); // Prevent default paste behavior
			const pastedText = event.clipboardData.getData('text/plain');

			const formatMobileNumberOnPaste = this.formatMobileNumberOnPaste(pastedText)
			event.target.value = formatMobileNumberOnPaste;
		},
		checkFormat() {
			let regexp =  /^\d{4}-\d{6}$/;
			
			if ( this.inputFields.mobileNumber !== null && this.inputFields.mobileNumber !=='' ) {
				this.mobileNumberIsValid = regexp.test(this.inputFields.mobileNumber);
			} else {
				this.mobileNumberIsValid = true;
			}

			this.$v.inputFields.mobileNumber.$touch();
		},
		checkCoverageValue() {
			if ( this.inputFields.coverage < 5 ) {
				this.inputFields.coverage = 5;
				this.$v.inputFields.coverage.$touch();
			} else {
				this.$v.inputFields.coverage.$touch();
			}	
		},
		numberOnlyInput(event) {
			const charCode = (event.which) ? event.which : event.keyCode;

			if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
				event.preventDefault();
			} else {
				return true;
			}
		},
		onBlurRate(model) {
			this.$v.inputFields[model].$touch()
			
			const priceFormat = parseFloat(this['inputFields'][model]).toFixed(2);
			this['inputFields'][model] = isNaN(priceFormat) ? parseFloat('0').toFixed(2) : priceFormat;
		}
	},
	validations() {
		return this.validationRules;
	}
}